<template>
  <div>
    <general-table 
        :columns="columns"
        :url="url"
        selectable
        :clickableRow="{ route: 'autoresponder.view', id: 'id' }"
        :selectActions="selectActions"
        itemNoun="autoresponder"
    />
  </div>
</template>

<script>
import AutoresponderTableButton from "@/components/AutoresponderTable/AutoresponderTableButton";
import AutoresponderStatus from "@/components/AutoresponderTable/AutoresponderStatus";
import AutoresponderType from "@/components/AutoresponderTable/AutoresponderType";
import AutoresponderTableActionDelete from "@/components/AutoresponderTableActionDelete";
import AutoresponderMessage from "@/components/AutoresponderTable/AutoresponderMessage";
import {markRaw} from 'vue';

export default {
  components: {
  },
  data() {
    return {
      url: route('autoresponders.table'),
        selectActions: [
            {
                label: "Delete",
                value: "delete",
                component: markRaw(AutoresponderTableActionDelete),
            }
        ],
      columns: [
        {
          label: "STATUS",
          name: "is_active",
          orderable: true,
          event: "click",
          component: markRaw(AutoresponderStatus),
          width: '120px',
        },
        {
          label: "AUTORESPONDER NAME",
          name: "title",
          orderable: true,
          transform: ({ data, name }) => `<p class="truncate w-64">${data[name]}</p>`,
        },
        {
          label: "MESSAGE",
          name: "message",
          orderable: true,
          component: markRaw(AutoresponderMessage),
        },
        {
          label: "TYPE",
          name: "type",
          orderable: true,
          component: markRaw(AutoresponderType),
        },
        {
          label: "",
          name: "View",
          orderable: false,
          event: "click",
          component: markRaw(AutoresponderTableButton),
          width: '120px',
        }
      ],
      bulkDelete: [],
      selectAll: false,
      deleteType: null,
      showDeletionModal: false,
    };
  },
  created() {
  },
  methods: {
  },
  computed: {
  }
};
</script>
